export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-add-0e05f08b4858cf9924a37e1b2a613667.svg";